import { render, staticRenderFns } from "./CourseLiveOnlineStudy.vue?vue&type=template&id=3b19011e&scoped=true&"
import script from "./CourseLiveOnlineStudy.vue?vue&type=script&lang=js&"
export * from "./CourseLiveOnlineStudy.vue?vue&type=script&lang=js&"
import style0 from "./CourseLiveOnlineStudy.vue?vue&type=style&index=0&id=3b19011e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b19011e",
  null
  
)

export default component.exports